import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'percentage-0', 'Percentage0', [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"}]]);